import React from 'react'
import Details from './details'
import Analytics from './analytics'
import SEO from './seo'

export default function LandingPageSettings({
    landingPage,
    LandingPageId,
    setLandingPage,
    saveLandingPage,
    shortCode,
    errors,
    domains,
    addDomain,
    url,
    sendingDomains = [],
    addTrackingDomain = () => {}
}) {
    const setOptions = (prop, value) => {
        const options = landingPage.options || {}
        options[prop] = value
        setLandingPage({ ...landingPage, options })
    }

    const setValue = (prop, value) => {
        console.log('setting', prop, value)
        setLandingPage({ ...landingPage, [prop]: value })
    }

    return (
        <div className='row'>
            <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6'>
                <Details
                    landingPage={landingPage}
                    saveLandingPage={saveLandingPage}
                    setOptions={setOptions}
                    setValue={setValue}
                    shortCode={shortCode}
                    errors={errors}
                    domains={domains}
                    addDomain={addDomain}
                    sendingDomains={sendingDomains}
                    url={url}
                    addTrackingDomain={addTrackingDomain}
                />
                <Analytics
                    landingPage={landingPage}
                    setValue={setValue}
                    saveLandingPage={saveLandingPage}
                    setOptions={setOptions}
                    errors={errors}
                />
            </div>
            <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6'>
                <SEO
                    landingPage={landingPage}
                    setValue={setValue}
                    saveLandingPage={saveLandingPage}
                    setOptions={setOptions}
                />
            </div>
        </div>
    )
}
